.track {
  display: block;
  width: 100%;
  border-radius: var(--radius-pill);
  background: var(--bg-active);
  overflow: hidden;
}

.sm {
  height: 6px;
}

.md {
  height: 8px;
}

.lg {
  height: 10px;
}

.fill {
  display: flex;
  width: var(--extent, 100%);
  height: 100%;
  border-radius: var(--radius-pill);
  overflow: hidden;
}

.segment {
  display: block;
  width: var(--share, 100%);
  height: 100%;
  background: var(--color, var(--text-muted));
}

/* Gapped: segments share the fill by flex-grow so the gaps don't overflow it,
   each rounded and never thinner than a dot */
.gapped {
  overflow: visible;
  background: var(--bg-active);
}

.gapped .fill {
  gap: 2px;
  overflow: visible;
}

.gapped .segment {
  flex: var(--grow, 1) 1 0;
  width: auto;
  min-width: 6px;
  border-radius: var(--radius-pill);
}
